
import { ReactNode, useEffect } from "react";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";

interface AuthProtectedRouteProps {
  children: ReactNode;
}

export const AuthProtectedRoute = ({ children }: AuthProtectedRouteProps) => {
  // Use the auth redirect hook with toast enabled
  useAuthRedirect('/auth', true, "Please sign in to access this page");
  
  // Simply render children if authenticated
  return <>{children}</>;
};
